<template lang="html">
  <div class="members form" v-loading="loading">

    <div class="cell title">
      <div class="check"></div>
      <div class="name">{{message.name}}</div>
      <div class="account">{{message.email}}</div>
      <div class="root" :title="message.Fl107">{{message.Fl107}}</div>
      <div class="transfer">{{message.Fl108}}</div>
      <div class="hiden" v-if = "role !== 2">{{message.Sl218}}</div>
      <div class="out"></div>
    </div>
    <div class="cell" v-for="(item, index) in members" :key="item.id">
      <div v-if="item.is_black === 0">
        <div class="check"></div>
        <div class="name" :title="item.name">
          {{item.name}}
        </div>
        <div class="account" :title="item.email">
          {{item.email}}
        </div>
        <div class="root" @click="modify(item.role, 0, item, index)">
          {{item.role}}
        </div>
        <div class="transfer" :title="item.operation" @click="modify(item.role, 0, item, index)">
          {{item.operation}}
        </div>
        <div class="hiden" v-if = "role !== 2">
          <div @click="hiden(index)">
            <i class="material-icons eye-off" v-show="item.isHide">visibility_off</i>
            <i class="material-icons eye-on" v-show="!item.isHide">visibility</i>
          </div>
        </div>
        <!-- <div class="other" @click="modify(item.role, 0, item, index)">
          {{item.bps}}
        </div> -->
        <i class="out material-icons" v-if = "item.role !== message.Sl138&& role !== 2" @click="openOut(item.id, item.name, index)">
          block
        </i>
      </div>
      <div v-if="item.is_black === 1" style="color:#757575">
        <div class="check"></div>
        <div class="name" :title="item.name">
          {{item.name}}
        </div>
        <div class="account" :title="item.email">
          {{item.email}}
        </div>
        <div class="root" style="width:335px" :title="message.Nl137">
          {{message.Nl137}}
        </div>
        <i class="out material-icons" v-if = "item.role !== message.Sl138 && role !== 2" @click="openOut(item.id, item.name, index)">
          block
        </i>
      </div>
    </div>
        <el-button type="primary" size="small" class="add-member" v-if="role !== 2" @click="openAddEmail();projectId = id;">
          {{message.Sl137}}
          <comp-email :toAddEmail="toAddEmail" :projectId="id" ref="addEmail"></comp-email>
        </el-button >
    <div class="page" v-show="total > 12">
      <el-pagination
        small
        layout="prev, pager, next"
        :page-size="12"
        :total="total"
        :current-page.sync="num"
        @current-change="membersList()"
      >
      </el-pagination>
    </div>
    <el-dialog class="dialog" width="520px" :title="data.name" :visible.sync="dialogOperation" append-to-body>
      <el-form ref="memberForm" :model="data" :rules="rules1" label-width="180px" style="width: 500px;text-align:left">
        <el-form-item :label="message.email">
          {{ data.email }}
        </el-form-item>
        <el-form-item :label="message.Fl107" v-show="data.roleValue!=='0'">
          <el-select v-model="data.roleValue" style="width: 110px">
            <el-option :label="message.Sl139" value="1"></el-option>
            <el-option :label="message.Sl140" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="message.Fl108" v-show="data.roleValue!=='0'">
          <el-select v-model="data.operationValue" style="width: 120px">
            <el-option :label="message.Sl141" value="0"></el-option>
            <el-option :label="message.Sl142" value="1"></el-option>
            <el-option :label="message.Sl143" value="2"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="限制上传速度：" v-show="data.operationValue !== '2'">
          <el-switch on-text="" off-text="" v-model="data.bpsUploadFalse"></el-switch>
        </el-form-item>
        <el-form-item label="总上传带宽：" v-show="data.bpsUploadFalse&&data.operationValue !== '2'">
          <el-col :span='9'>
            <el-form-item prop="upload">
              <el-input v-model.number="data.uploadValue" style="width:100px"></el-input>
            </el-form-item>
          </el-col>
          <el-select v-model="data.uploadUnit" style="width: 85px">
            <el-option v-for="item in options"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="限制下载速度：" v-show="data.operationValue !=='1'">
          <el-switch on-text="" off-text="" v-model="data.bpsDownloadFalse"></el-switch>
        </el-form-item>
        <el-form-item label="总下载带宽：" v-show="data.bpsDownloadFalse&&data.operationValue !=='1'">
          <el-col :span='9'>
            <el-form-item prop="download">
              <el-input v-model.number="data.downloadValue" style="width:100px"></el-input>
            </el-form-item>
          </el-col>
          <el-select v-model="data.downloadUnit" style="width: 85px">
            <el-option v-for="item in options"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item> -->
         <el-form-item style="padding-top:20px">
          <el-button type="primary" @click="onSubmit">{{message.Fl102}}</el-button>
          <el-button @click="reset">{{message.Fl101}}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import CompEmail from '@/components/addEmail.vue'

export default {
  components: {
    CompEmail
  },
  data () {
    var checkUpload = (rule, value, callback) => {
      if (this.data.bpsUploadFalse) {
        if (this.data.uploadValue === '') {
          return callback(new Error(this.$lang.ui.prompt.l129))
        }
        if (this.data.uploadValue === 0) {
          return callback(new Error(this.$lang.ui.prompt.l130))
        }
        if (!Number.isInteger(this.data.uploadValue)) {
          return callback(new Error(this.$lang.ui.prompt.l131))
        }
      }
      callback()
    }
    var checkDownload = (rule, value, callback) => {
      if (this.data.bpsDownloadFalse) {
        if (this.data.downloadValue === '') {
          return callback(new Error(this.$lang.ui.prompt.l129))
        }
        if (this.data.downloadValue === 0) {
          return callback(new Error(this.$lang.ui.prompt.l130))
        }
        if (!Number.isInteger(this.data.downloadValue)) {
          return callback(new Error(this.$lang.ui.prompt.l131))
        }
      }
      callback()
    }
    return {
      message: {
        name: this.$lang.ui.form.name,
        email: this.$lang.ui.form.email,
        Fl101: this.$lang.ui.form.l101,
        Fl102: this.$lang.ui.form.l102,
        Fl107: this.$lang.ui.form.l107,
        Fl108: this.$lang.ui.form.l108,
        Fl109: this.$lang.ui.form.l109,
        Sl137: this.$lang.ui.system.l137,
        Sl138: this.$lang.ui.system.l138,
        Sl139: this.$lang.ui.system.l139,
        Sl140: this.$lang.ui.system.l140,
        Sl141: this.$lang.ui.system.l141,
        Sl142: this.$lang.ui.system.l142,
        Sl143: this.$lang.ui.system.l143,
        Sl218: this.$lang.ui.system.l218,
        Nl137: this.$lang.ui.notice.l137
      },
      toAddEmail: false,
      loading: false,
      dialogOperation: false,
      num: 1,
      total: 12,
      members: [],
      data: '',
      formLabelWidth: '120px',
      options: [
        {
          value: 0,
          label: 'bps'
        },
        {
          value: 1,
          label: 'Kbps'
        },
        {
          value: 2,
          label: 'Mbps'
        },
        {
          value: 3,
          label: 'Gbps'
        }
      ],
      rules1: {
        upload: [
          { validator: checkUpload, trigger: 'blur' }
        ],
        download: [
          { validator: checkDownload, trigger: 'blur' }
        ]
      }
    }
  },
  props: {
    id: String,
    role: Number,
  },
  mounted () {
    this.num = 1
    this.getMembers(1)
  },
  methods: {
    membersList () {
      this.getMembers(this.num)
    },
    getMembers (num) {
      this.loading = true
      this.members = []
      this.$http.get('/cydex/api/v1/projects/' + this.id + '/members', { params: {
        'page_size': 12,
        'page_num': num,
        'with_perm': 1
      } })
        .then(response => {
          this.members = []
          this.loading = false
          this.total = response.data.total_num
          var data = response.data.members
          for (var i = 0; i < data.length; i++) {
            var role = [this.$lang.ui.system.l138, this.$lang.ui.system.l139, this.$lang.ui.system.l140]
            var bps = ''
            if (this.role === 2) {
              if (data[i].user_info.id === localStorage.getItem('uid')) {
                var operation = [this.$lang.ui.system.l141, this.$lang.ui.system.l142, this.$lang.ui.system.l143]
                bps = this.$lang.ui.system.l144
                if (
                  data[i].permission.upload_max_bps !== 0 &&
                data[i].permission.download_max_bps !== 0
                ) {
                  bps = this.$lang.ui.system.l145 + this._global.bpsSwitch(data[i].permission.upload_max_bps) + ' / ' + this.$lang.ui.system.l146 + this._global.bpsSwitch(data[i].permission.download_max_bps)
                } else {
                  if (data[i].permission.upload_max_bps !== 0) {
                    bps = this.$lang.ui.system.l145 + this._global.bpsSwitch(data[i].permission.upload_max_bps)
                  }
                  if (data[i].permission.download_max_bps !== 0) {
                    bps = this.$lang.ui.system.l146 + this._global.bpsSwitch(data[i].permission.download_max_bps)
                  }
                }
              } else {
                operation = ['', '', '']
              }
              var isHide = ''
            } else {
              operation = [this.$lang.ui.system.l141, this.$lang.ui.system.l142, this.$lang.ui.system.l143]
              bps = this.$lang.ui.system.l144
              var bpsUploadFalse = false
              var bpsDownloadFalse = false
              var uploadValue = this._global.bps(data[i].permission.upload_max_bps).value
              var downloadValue = this._global.bps(data[i].permission.download_max_bps).value
              var uploadUnit = this._global.bps(data[i].permission.upload_max_bps).unit
              var downloadUnit = this._global.bps(data[i].permission.download_max_bps).unit
              if (
                data[i].permission.upload_max_bps !== 0 &&
              data[i].permission.download_max_bps !== 0
              ) {
                bpsUploadFalse = true
                bpsDownloadFalse = true
                bps = this.$lang.ui.system.l145 + this._global.bpsSwitch(data[i].permission.upload_max_bps) + ' / ' + this.$lang.ui.system.l146 + this._global.bpsSwitch(data[i].permission.download_max_bps)
              } else {
                if (data[i].permission.upload_max_bps !== 0) {
                  bpsUploadFalse = true
                  bps = this.$lang.ui.system.l145 + this._global.bpsSwitch(data[i].permission.upload_max_bps)
                }
                if (data[i].permission.download_max_bps !== 0) {
                  bpsDownloadFalse = true
                  bps = this.$lang.ui.system.l146 + this._global.bpsSwitch(data[i].permission.download_max_bps)
                }
              }
              isHide = data[i].permission.is_hide
            }
            this.members.push({
              is_black: data[i].user_info.is_black_user,
              id: data[i].user_info.id,
              name: data[i].user_info.name,
              email: data[i].user_info.email,
              role: role[data[i].permission.role],
              operation: operation[data[i].permission.operation],
              bps: bps,
              roleValue: (data[i].permission.role).toString(),
              bpsDownloadFalse: bpsDownloadFalse,
              bpsUploadFalse: bpsUploadFalse,
              uploadValue: uploadValue,
              downloadValue: downloadValue,
              uploadUnit: uploadUnit,
              downloadUnit: downloadUnit,
              operationValue: (data[i].permission.operation).toString(),
              isHide: isHide
            })
          }
        })
    },
    out (id, index) {
      this.$http.put('/cydex/api/v1/projects/' + this.id + '/members', {
        'remove_users': [id]
      })
        .then(response => {
          this.members.splice(index, 1)
          this.$message({
            message: this.$lang.ui.prompt.l132,
            type: 'success',
            duration: 2000
          })
        })
    },
    openOut (id, name, index) {
      this.$confirm(this.$lang.ui.prompt.l133.l0 + name + this.$lang.ui.prompt.l133.l1, this.$lang.ui.system.l133, {
        confirmButtonText: this.$lang.ui.form.l100,
        cancelButtonText: this.$lang.ui.form.l101,
        type: 'warning'
      })
        .then(() => {
          this.out(id, index)
        })
        .catch(() => {
        })
    },
    openAddEmail () {
      this.toAddEmail = true
      this.$refs.addEmail.showBox()
    },
    modify (role, position, item, index) {
      if (this.role !== 2) {
        if (role !== this.$lang.ui.system.l138 || position !== 0) {
          this.dialogOperation = true
          this.data = JSON.parse(JSON.stringify(item))
        }
      }
    },
    reset () {
      this.dialogOperation = false
      this.$refs['memberForm'].resetFields()
    },
    onSubmit (index) {
      this.$refs['memberForm'].validate((valid) => {
        if (valid) {
          // var upload = 0
          // var download = 0
          // if (this.data.operationValue !== '2' && this.data.bpsUploadFalse) {
          //   var upload = Math.pow(1024, parseInt(this.data.uploadUnit)) * this.data.uploadValue
          // } else {
          //   upload = 0
          // }
          // if (this.data.operationValue !== '1' && this.data.bpsDownloadFalse) {
          //   var download = Math.pow(1024, parseInt(this.data.downloadUnit)) * this.data.downloadValue
          // } else {
          //   download = 0
          // }
          this.$http.put('/cydex/api/v1/projects/' + this.id + '/members/permissions', {
            'user_id': this.data.id,
            'permission': {
              'role': parseInt(this.data.roleValue),
              'operation': parseInt(this.data.operationValue),
              // 'upload_max_bps': upload,
              // 'download_max_bps': download,
              'is_hide': parseInt(this.data.isHide) ? 1 : 0
            }
          })
            .then(response => {
              this.dialogOperation = false
              this.$refs['memberForm'].resetFields()
              this.getMembers(this.num)
              this.$message({
                message: this.$lang.ui.prompt.l117,
                type: 'success',
                duration: 4000
              })
            })
        }
      })
    },
    hiden (index) {
      var isHide = parseInt(this.members[index].isHide) ? 0 : 1
      this.$http.put('/cydex/api/v1/projects/' + this.id + '/members/permissions', {
        'user_id': this.members[index].id,
        'permission': {
          'role': parseInt(this.members[index].roleValue),
          'operation': parseInt(this.members[index].operationValue),
          'is_hide': isHide
        }
      })
        .then(response => {
          this.members[index].isHide = parseInt(this.members[index].isHide) ? 0 : 1
          this.$message({
            message: this.$lang.ui.prompt.l117,
            type: 'success',
            duration: 4000
          })
        })
    }
  }
}
</script>

<style lang="css">
.members.form {
  position: relative;
  background-color: #fff;
  padding: 20px;
  padding-bottom: 40px;
  width: 810px;
  margin: 15px auto;
  border-radius: 4px;
  height: 528px;
  -webkit-box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.149019607843137);
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.149019607843137);
}
.members .page {
  position: absolute;
  text-align: center;
  width: 100%;
  bottom: 6px;
}
.members .cell {
  height: 36px;
  width: 100%;
}
.members .cell.title {
  font-weight: 600;
  border-bottom: 1px solid #cdcdcd;
  line-height: 30px;
}
.members .check,
.members .name,
.members .account,
.members .root,
.members .transfer,
.members .other,
.members .out,
.members .hiden
 {
  display: block;
  text-align: left;
  padding-right: 15px;
  font-size: 14px;
  float: left;
  height: 36px;
  line-height: 36px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.members .account {
  width: calc(100% - 580px)
}
.members .hiden {
  padding-top: 7px;
  width: 100px;
}
.members .cell.title .hiden {
  padding-top: 0;
}
.members .eye-on {
  color: #409EFF;
}
.members .eye-off {
  color: #757575;
}
.members .hiden i {
  font-size: 23px;
  cursor: pointer;
}
.members .check {
  width: 35px;
  padding-right: 0;
  text-align: center;
}
.members .name {
  width: 140px;
}
.members .root {
  width: 100px;
  cursor: pointer;
}
.members .root:hover {
  text-decoration: underline;
}
.members .transfer {
  width: 135px;
  cursor: pointer;
}
.members .transfer:hover {
  text-decoration: underline;
}
.members .other {
  cursor: pointer;
  width: 240px;
}
.members .other:hover {
  text-decoration: underline;
}
.members .out {
  display: none;
  text-align: center;
  cursor: pointer;
  padding-right: 0;
  width: 35px;
  font-size: 24px;
}
.members .out:hover {
  color: #d43f3a;
}
.members .cell:hover {
  background-color: #e6e6e6;
  border-radius: 4px;
}
.members .cell:hover .out {
  display: inline-block;
}
.members .add-member {
  position: absolute;
  bottom: 10px;
  left: 15px;
  z-index: 99;
}
.members .el-loading-mask {
  background-color: transparent !important;
}
.members .dialog .el-dialog--small {
  width: 680px !important;
}
.members .el-form-item__content {
  padding-left: 30px;
}
.members .el-col .el-form-item__content {
  padding-left: 0;
}
</style>
